import axios from 'axios'
import Cookies from 'js-cookie'

export const getBatchesList = (query: any): any => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/events/get-events-batches?${query}`, {
      headers: {
        Authorization: 'Bearer ' + Cookies.get('token'),
      }
    })
    .then((res: any) => {
      return {...res, data: res.data.result, total: res.data.total}
    })
}